import { render, staticRenderFns } from "./EdFormItem.vue?vue&type=template&id=1ddd068a&scoped=true&"
import script from "./EdFormItem.vue?vue&type=script&lang=js&"
export * from "./EdFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddd068a",
  null
  
)

export default component.exports